export abstract class NgInternalLinkService {
    abstract check(link: string): Promise<any>;
    abstract checkId(id: string): Promise<any>;
}
